const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const handleResponse = async (res, errorMessage) => {
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.message || errorMessage || "Request failed");
  }
  return data;
};

// Current Weather — via your backend
export const getWeather = async (city) => {
  const res = await fetch(
    `${API_BASE_URL}/api/weather/current?city=${encodeURIComponent(city.trim())}`
  );
  return handleResponse(res, "City not found. Please check the name and try again.");
};

// 5-Day Forecast — via your backend
export const getForecast = async (city) => {
  const res = await fetch(
    `${API_BASE_URL}/api/weather/forecast?city=${encodeURIComponent(city.trim())}`
  );
  const data = await handleResponse(res, "Unable to fetch forecast.");

  const days = {};
  data.list.forEach((entry) => {
    const date = new Date(entry.dt * 1000);
    const dateValue = Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    const key = date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      timeZone: "UTC",
    });
    if (!days[key]) {
      days[key] = {
        key,
        dateValue,
        temps: [],
        condition: entry.weather[0].main,
        description: entry.weather[0].description,
      };
    }
    days[key].temps.push(entry.main.temp);
  });

  const now = new Date();
  const todayValue = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate()
  );
  const allDays = Object.values(days).sort(
    (a, b) => a.dateValue - b.dateValue
  );
  const futureDays = allDays.filter((d) => d.dateValue > todayValue);
  const selectedDays =
    futureDays.length >= 5 ? futureDays.slice(0, 5) : allDays.slice(0, 5);

  return selectedDays.map((d) => ({
      label: d.key,
      high: Math.round(Math.max(...d.temps)),
      low: Math.round(Math.min(...d.temps)),
      condition: d.condition,
      description: d.description,
    }));
};

// Search History
export const getHistory = async () => {
  const res = await fetch(`${API_BASE_URL}/api/weather/history/all`);
  return handleResponse(res, "Unable to load history.");
};

// Clear History
export const clearHistory = async () => {
  const res = await fetch(`${API_BASE_URL}/api/weather/history/all`, {
    method: "DELETE",
  });
  return handleResponse(res, "Unable to clear history.");
};